class EstimateShipping extends HTMLElement {
    constructor() {
        super();
        this.initShippingCalc = this.initShippingCalc.bind(this);
        this.generateShippingRates = this.generateShippingRates.bind(this);
    }

    connectedCallback() {
        this.initShippingCalc();
        this.addEventListeners();
    }

    async initShippingCalc(preload = false) {
        const element = this.querySelector('#es-shipping-calc');
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        const cartFooter = document.querySelector('.cart__footer');

        new Shopify.CountryProvinceSelector('es-shipping-calc-country', 'es-shipping-calc-province', {
            hideElement: 'es-shipping-calc-province-wrapper'
        });

        if (cartDrawerItems && !cartDrawerItems.classList.contains('is-empty')) {
            document.querySelector('#CartDrawer #es-shipping-calc').style.display = 'block';
        }

        if (cartFooter) {
            document.querySelector('#MainContent #es-shipping-calc').style.display = 'block';
        }
    }

    addEventListeners() {
        const selectAllshippingCountry = this.querySelectorAll("#es-shipping-calc-country");
        let selectedValue;

        selectAllshippingCountry.forEach(selectElement => {
            selectElement.addEventListener("change", (event) => {
                selectedValue = event.target.selectedOptions[0];

                selectAllshippingCountry.forEach(element => {
                    const optionToSelect = Array.from(element.options).find(option => option.value === selectedValue.value);
                    if (optionToSelect) {
                        optionToSelect.selected = true;

                        const dataProvinces = selectedValue.getAttribute('data-provinces');
                        if (dataProvinces) {
                            const allProvinceWrappers = this.querySelectorAll("#es-shipping-calc-province-wrapper");
                            const dataProvincesArr = dataProvinces.split(" ");
                            if (dataProvincesArr.length > 1) {
                                allProvinceWrappers.forEach(wrapper => {
                                    wrapper.style.display = 'block';
                                });
                            } else {
                                allProvinceWrappers.forEach(wrapper => {
                                    wrapper.style.display = 'none';
                                });
                            }
                        }
                    }
                });

                new Shopify.CountryProvinceSelector('es-shipping-calc-country', 'es-shipping-calc-province', {
                    hideElement: 'es-shipping-calc-province-wrapper'
                });
            });
        });

        const generateShippingRatesButton = this.querySelector('#es-shipping-calc-btn');
        if (generateShippingRatesButton) {
            generateShippingRatesButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.generateShippingRates(event.currentTarget);
            });
        }
    }

    async generateShippingRates(btn) {
        if (btn.disabled) return;

        const loadingSpinner = btn.querySelector('.loading__spinner');
        const wrapper = btn.closest('estimate-shipping');
        const alertDanger = wrapper.querySelector('#es-shipping-calc-alert-danger');
        const alertWarning = wrapper.querySelector('#es-shipping-calc-alert-warning');
        const alertSuccess = wrapper.querySelector('#es-shipping-calc-alert-success');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 30000);

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('loading');
        loadingSpinner?.classList.remove('hidden');
        [alertDanger, alertWarning, alertSuccess].forEach(alert => {
            alert.replaceChildren();
            alert.setAttribute('hidden', 'hidden');
            alert.setAttribute('aria-live', 'polite');
        });

        try {
            const params = new URLSearchParams({
                'shipping_address[zip]': wrapper.querySelector('#es-shipping-calc-zip').value.trim(),
                'shipping_address[country]': wrapper.querySelector('#es-shipping-calc-country').value,
                'shipping_address[province]': wrapper.querySelector('#es-shipping-calc-province').value
            });
            const root = window.Shopify?.routes?.root || '/';
            const request = async (endpoint, method = 'GET') => {
                const response = await fetch(root + 'cart/' + endpoint + '?' + params, {
                    method,
                    signal: controller.signal
                });
                if (!response.ok) {
                    let message = '';
                    if (response.status === 422) {
                        const errors = await response.json().catch(() => null);
                        if (errors && typeof errors === 'object') {
                            message = Object.entries(errors).map(([key, value]) =>
                                key.replace(/_/g, ' ') + ': ' + (Array.isArray(value) ? value.join(', ') : String(value))
                            ).join('. ');
                        }
                    }
                    throw new Error(message || "We couldn't calculate shipping right now. Please try again or continue to checkout.");
                }
                return response;
            };

            await request('prepare_shipping_rates.json', 'POST');
            let rates;
            // Shopify returns null while carrier rates are still being calculated.
            for (let attempt = 0; attempt < 30; attempt++) {
                const response = await request('async_shipping_rates.json');
                const data = await response.json();
                if (data !== null) {
                    if (!Array.isArray(data?.shipping_rates)) throw new Error();
                    rates = data.shipping_rates;
                    break;
                }
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
            if (!rates) throw new Error();

            if (rates.length) {
                const list = document.createElement('ul');
                rates.forEach(rate => {
                    const item = document.createElement('li');
                    const price = document.createElement('strong');
                    item.textContent = (rate.presentment_name || rate.name || 'Shipping') + ': ';
                    price.textContent = rate.price + (rate.currency ? ' ' + rate.currency : '');
                    item.append(price);
                    list.append(item);
                });
                alertSuccess.append(list);
                alertSuccess.removeAttribute('hidden');
            } else {
                alertWarning.textContent = 'No shipping rates found for this address. Please check your details or continue to checkout.';
                alertWarning.removeAttribute('hidden');
            }
        } catch (error) {
            alertDanger.textContent = error.name !== 'AbortError' && error.message
                ? error.message
                : "We couldn't calculate shipping right now. Please try again or continue to checkout.";
            alertDanger.removeAttribute('hidden');
        } finally {
            clearTimeout(timeout);
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.classList.remove('loading');
            loadingSpinner?.classList.add('hidden');
        }
    }
}

customElements.define('estimate-shipping', EstimateShipping);
